export function useUtils() {
	function loadAliyunCaptchaNew(aliyunCaptchaIsLoad){
		if(window.initAliyunCaptcha == undefined){
			const oScript = document.createElement( 'script' );
			oScript.type = 'text/javascript';
			oScript.src = 'https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js';
			oScript.onload = function(){
				if (aliyunCaptchaIsLoad) {
					aliyunCaptchaIsLoad.value = true;
				}
			};
			document.body.appendChild( oScript );
		} else {
			if (aliyunCaptchaIsLoad) {
				aliyunCaptchaIsLoad.value = true;
			}
		}
	}

  function getRootUrl( productKey ){
    let rootUrl = '/api';
    if(productKey === 'servicecloud'){
      rootUrl = '/v2/api';
    }
    return rootUrl;
  }

	// 通过返回值暴露所管理的状态
	return {
    getRootUrl,
		loadAliyunCaptchaNew
	};
}